import * as React from 'react';
import FormView from '../../FormView';
import UserNotifications from '../../common/UserNotifications';
import { IInTransitProperties } from '../interfaces';

class InTransit extends React.PureComponent<IInTransitProperties> {

  componentDidMount(): void {
    const { path, onInitialLoad } = this.props;
    if (path) {
      switch (path) {
        case '/purchase-order-enquiry/in-transit/local-shipments':
          onInitialLoad('InTransitLocalShipments');
          break;
        case '/purchase-order-enquiry/in-transit/import-shipments':
          onInitialLoad('InTransitImportShipments');
          break;
        default:
          onInitialLoad('InTransitLocalShipments');
      }
    }
  }

  render(): React.ReactNode {
    const { isBrowseLookUpOpen, selectedTab, selectedForm, operationMode } = this.props;

    return (selectedForm &&
      <React.Fragment>
        <UserNotifications
          notifications={this.props.notifications}
          entity='InTransit'
        />
        <FormView
          formName='InTransit'
          browseLookUpOpen={isBrowseLookUpOpen}
          browseLookUpComponent={selectedTab}
          schema={selectedForm}
          includeTabsHeight={false}
          operationMode={operationMode}
          enableReinitialize={true}
        />
      </React.Fragment>
    );
  }
}

export default InTransit;
